/**
 * Qui voit quoi — une seule liste pour tous (2026-09-14).
 *
 * Jusqu'au 2026-09-14, un profil ACHETEUR était refoulé de la page Annonces
 * (écran ResellerOnlyGate, 403 RESELLER_ONLY côté serveur). Depuis la
 * suppression d'« Autour de moi » (2026-09-03), cette porte laissait l'abonné
 * Particulier sans aucune annonce à consulter. Elle est levée : tout le monde
 * parcourt la même liste, et c'est l'ABONNEMENT qui décide de ce que porte la
 * carte. Le masquage est fait par le serveur (plan_limits), jamais ici : ces
 * fonctions ne choisissent que des libellés.
 *
 * Le profil vient de deux sources :
 *   - visiteur non inscrit : localStorage `zk_profil` (posé par l'accueil)
 *   - utilisateur inscrit  : `user.profile_type`
 * `profile_type` a deux conventions historiques (inscription :
 * particulier/revendeur/garage ; onboarding : FIRST_BUYER/RESELLER/OTHER) —
 * les deux sont reconnues ici.
 */

const BUYER_PROFILES    = ['particulier', 'first_buyer'];
const RESELLER_PROFILES = ['revendeur', 'reseller', 'garage'];

/** Plans donnant les outils d'achat-revente (cf. backend plan_limits.RESELLER_PLANS). */
export const RESELLER_PLANS = ['REVENDEURPASS', 'PROPASS', 'GARAGEPASS', 'ULTRAPASS'];

/** Plans acheteur seuls — économies affichées, jamais les marges de revente. */
export const BUYER_PLANS = ['PARTICULIERPASS', 'JEUNEPASS'];

function normalize(value) {
  return (value || '').trim().toLowerCase();
}

export function readStoredProfile() {
  try {
    return normalize(localStorage.getItem('zk_profil'));
  } catch {
    return '';
  }
}

/** Profil effectif : celui du compte s'il existe, sinon celui choisi sur l'accueil. */
export function getProfile(user) {
  const fromUser = normalize(user?.profile_type);
  return fromUser || readStoredProfile();
}

export function isBuyerProfile(user) {
  return BUYER_PROFILES.includes(getProfile(user));
}

export function isResellerProfile(user) {
  return RESELLER_PROFILES.includes(getProfile(user));
}

export function hasResellerPlan(user) {
  return !!user?.is_admin || RESELLER_PLANS.includes(user?.subscription_plan);
}

/** Abonné acheteur (Particulier, Jeune) : il lit « vous économisez », pas « marge ». */
export function isBuyerPlan(user) {
  return !user?.is_admin && BUYER_PLANS.includes(user?.subscription_plan);
}

/** Destination du bouton générique « parcourir les annonces » : la même pour tous. */
export function browsePath() {
  return '/explore';
}
